import { addQueryParams, useRouter } from '@main/core-ui';
import { getUnderlyingPath } from '@main/internationalization';
import PendingRequests from '@main/privacy-center/src/containers/PendingRequests';
import React from 'react';
import { useIntl } from 'react-intl';
import { useSelector } from 'react-redux';

import { selectDataSubjects } from '../ActiveDataSubject/selectors';
import { takeControlMessages } from '../TakeControl/messages';
import { RequestHistoryPreviewWrapper } from './wrappers';

/**
 * Request history login
 */
export const RequestHistoryLogin: React.FC<
  React.PropsWithChildren<unknown>
> = () => {
  const { formatMessage } = useIntl();
  const { redirect, location } = useRouter();
  const dataSubjects = useSelector(selectDataSubjects);
  const { locale } = getUnderlyingPath(location.pathname);

  const newPath = locale ? `/login/${locale}` : '/login';

  return (
    <RequestHistoryPreviewWrapper>
      <PendingRequests
        loading={false}
        requests={[]}
        activeNotificationCount={0}
        showAll={false}
        setShowAll={() => null}
        onClick={() =>
          redirect(
            dataSubjects.length > 1
              ? addQueryParams(location, {
                  modal: 'select-subject',
                  redirectTo: newPath,
                })
              : newPath,
          )
        }
        preview={formatMessage(takeControlMessages.viewPastRequests)}
      />
    </RequestHistoryPreviewWrapper>
  );
};
